module.exports = __webpack_public_path__ + "media/images/icons/icon-wrap-bf1127c286948a92d13a405bfaa8c8f3.svg";